<div class="card">
  <h3>{{ meeting.meetingType?.label ?? '' }}</h3>
  <p class="date">{{ formatDateTime(meeting.startAt) }}</p>
  <p>{{ meeting.meetingType?.durationInMinutes }} Minutes</p>
  <p
    class="status-badge"
    [ngStyle]="{
      backgroundColor: getMeetingStatusColor(),
      color: getMeetingStatusTextColor()
    }">
    {{ getMeetingStatusLabel() }}
  </p>
</div>
